module.exports = {
  HTML_TAGS: /<[^>]*(>|$)|&nbsp;|&zwnj;|&raquo;|&laquo;|&gt;/g,
  UNIX_FILE_NAME: /(?!.{256,})[^ /][ .\w-$()+=[\];#@~,&'^`!%{}<>|]+[^. ]$/i,
  UNIX_FILE_PATH: /^\/(?:[^/]+\/)*[^/:*?"<>|]+\//,
  WINDOWS_FILE_NAME: /(?!.{256,})(?!(aux|clock\$|con|nul|prn|com[1-9]|lpt[1-9])(?:$|\.))[^ \\][ .\w-$()+=[\];#@~,&'^`!%{}]+[^. ]$/i,
  WINDOWS_FILE_PATH: /^[a-zA-Z]:\\([^\\/:*?"<>|]+\\)*/,
};
